import { render, staticRenderFns } from "./questionOrder.vue?vue&type=template&id=381374f8&scoped=true"
import script from "./questionOrder.vue?vue&type=script&lang=js"
export * from "./questionOrder.vue?vue&type=script&lang=js"
import style0 from "./questionOrder.vue?vue&type=style&index=0&id=381374f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381374f8",
  null
  
)

export default component.exports